export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const money = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

/**
 * "March 2026".
 *
 * `month` is 0-11, so a missing month must not fall through to January, and a
 * missing year must not leave a bare month name that reads as this year's.
 * Guarding here rather than at each call site: seventeen files use this.
 */
export const periodLabel = (month, year) => {
  const i = Number(month);
  if (!Number.isInteger(i) || i < 0 || i > 11 || !year) return "—";
  return `${MONTHS[i]} ${year}`;
};

export const RUN_STATUS_TONE = {
  draft: "muted",
  pending_approval: "warning",
  approved: "success",
  rejected: "danger",
  paid: "info",
};

export const RUN_STATUS_LABEL = {
  draft: "Draft",
  pending_approval: "Pending approval",
  approved: "Approved",
  rejected: "Rejected",
  paid: "Paid",
};

/**
 * What a single line's state is, in the run it belongs to.
 *
 * The book's payroll table ends in a per-employee status, and the one that
 * matters is "No bank": a line can be perfectly calculated and still not be
 * payable. That outranks where the run as a whole has got to, because it is the
 * only one of these states that needs somebody to go and do something before
 * pay day, and it used to surface only when the bank file was generated —
 * after approval, and too late to fix quietly.
 *
 * Everything else is the run's own status said per row, so the reader does not
 * have to look back up at the header to know whether a line is settled.
 */
export const RUN_LINE_STATUS = {
  draft: { label: "Draft", tone: "muted" },
  pending_approval: { label: "Needs approval", tone: "warning" },
  approved: { label: "Ready", tone: "success" },
  rejected: { label: "Rejected", tone: "danger" },
  paid: { label: "Paid", tone: "info" },
};

export const lineStatus = (item, runStatus) => {
  // Explicitly `=== false`: a line written before the field existed has it
  // undefined, and "we do not know" must not be reported as "no bank".
  if (item?.bankDetailsOnFile === false) return { label: "No bank", tone: "danger" };
  return RUN_LINE_STATUS[runStatus] || { label: runStatus || "—", tone: "muted" };
};
